import type { FC } from 'react';
import React from 'react';

import type { TDesktop } from '../models/desktop';

export const BannerBackground: FC<TDesktop> = props => {
    const {
        Background,
        ResponsiveBackground,
        background,
        backgroundId,
        children,
        className,
        imageSources,
    } = props;
    const sources = imageSources(props);
    const commonProps = {
        background,
        className,
        children,
        dataTestId: 'mainBanner',
        id: backgroundId,
    };

    /* istanbul ignore if */
    if (sources.length === 1) {
        return <Background {...commonProps} image={sources[0].src} />;
    }

    return <ResponsiveBackground {...commonProps} sources={sources} />;
};
